<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { useRequestDetailsStore } from '@Stores/requestDetails.store';
import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
import { useFlowSteps } from '@Use/useFlowSteps';
import useDashboardContext from '@Use/useDashboardContext';
import { DetailsLayout, FlowLayout, IllustrationSendPriming } from '@Shared';
import ConfirmCompleteContent from '@Components/confirm/ConfirmCompleteContent.vue';

const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const requestDetailsStore = useRequestDetailsStore();
const { getProgressSteps, getCurrentStep } = useFlowSteps();
const steps = getProgressSteps();
const { isDashboardContext, isLoadingContext } = useDashboardContext();

const isLoading = ref(true);
const isPageLoading = computed(() => isLoading.value || isLoadingContext.value);


onMounted(async () => {
    isLoading.value = true;
    await requestDetailsStore.fetchRequestDetails();
    isLoading.value = false;
});
</script>

<template>
    <app-page-loader v-if="isPageLoading" />

    <details-layout
        v-else-if="isDashboardContext"
        title="Your bank account details"
        illustration-align="bottom"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl">
        <template #illustration>
            <illustration-send-priming />
        </template>

        <confirm-complete-content :show-title="false" />
    </details-layout>

    <flow-layout
        v-else
        is-white-label
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        :steps="steps"
        :current-step="getCurrentStep()">

        <confirm-complete-content />
    </flow-layout>
</template>
